/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileText16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M9.5 11c.245 0 .45.183.492.412L10 11.5c0 .276-.23.5-.5.5h-7a.505.505 0 01-.5-.5c0-.276.23-.5.5-.5h7zm4-3c.245 0 .45.183.492.412L14 8.5c0 .276-.229.5-.5.5h-11a.505.505 0 01-.5-.5c0-.276.229-.5.5-.5h11zm-1.001-3c.246 0 .45.183.493.412L13 5.5c0 .276-.23.5-.501.5H2.5a.505.505 0 01-.5-.5c0-.276.23-.5.501-.5H12.5z"
        />
    </AccessibleSVG>
);

export default FileText16;
